export default __webpack_public_path__ + "static/media/ic_xrp_96.1ab84cae.svg";